import React, { useState } from 'react'
import {
  Icon,
  IconButton,
  Menu,
  MenuList,
  MenuItem,
  ListItemText,
} from '@material-ui/core'

import { useIntl } from 'react-intl'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import * as R from 'ramda'

const useStyle = makeStyles((theme) => ({
  menuRoot: {
    '& .MuiList-padding': {
      paddingTop: '2px',
      paddingBottom: '2px',
      paddingLeft: '2px',
      paddingRight: '2px',
    },
  },
}))

const VOUCHER_STATUS_ACTIVE = 1
const ALLOWED_CANCEL_STATUS = [VOUCHER_STATUS_ACTIVE]

function DealPromotionRowMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null)
  const { onMenuCancel, data } = props
  function openMenu(event) {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  function closeMenu(event) {
    event.stopPropagation()
    setAnchorEl(null)
  }

  const { formatMessage } = useIntl()
  const classes = useStyle()
  const status = R.prop('status', data)

  return (
    <div className="flex w-full justify-center items-center">
      <IconButton
        color="secondary"
        className="p-0"
        aria-owns={anchorEl ? 'selectMenu' : null}
        aria-haspopup="true"
        onClick={openMenu}
      >
        <Icon>more_vert</Icon>
      </IconButton>
      <Menu
        id="selectMenu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        className={clsx(classes.menuRoot)}
      >
        <MenuList className={clsx(classes.menuRoot)}>
          {ALLOWED_CANCEL_STATUS.includes(status) && (
            <MenuItem
              onClick={(event) => {
                event.stopPropagation()
                onMenuCancel()
              }}
            >
              <ListItemText
                primary={formatMessage({
                  id: 'dealsPromotions.table.menu.cancel',
                })}
              />
            </MenuItem>
          )}
          <MenuItem onClick={(event) => {}}>
            <ListItemText
              primary={formatMessage({
                id: 'edit.label',
              })}
            />
          </MenuItem>
        </MenuList>
      </Menu>
    </div>
  )
}

export default DealPromotionRowMenu
